/**
 * Emit hosts for the `voice` analytics group — 1 function
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { type VoiceStyle } from '@heidi/schema/ml-scribe';

export function trackVoiceStyleUpdated(input: {
  sessionId: string;
  voiceStyle: VoiceStyle;
  oldVoiceStyle?: VoiceStyle;
  tabType: 'note' | 'document';
  isRegenerate?: boolean;
}) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.VoiceStyleUpdated,
    props: {
      session_id: input.sessionId,
      voice_style: input.voiceStyle,
      old_voice_style: input.oldVoiceStyle,
      tab_type: input.tabType,
      is_regenerate: input.isRegenerate,
    },
  });
}
